import { timer, Observable, Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';

/**
 * Creates a timer observable that emits every second
 * @param destroySubject Subject to complete the observable when component unmounts
 * @param intervalMS amount of milliseconds between emissions (default 1000ms)
 * @returns Observable that emits the current timestamp every second
 */
export const createTimerObservable = (
  destroySubject: Subject<void>,
  intervalMS = 1000,
): Observable<number> => {
  // Emit once on subscribe so timers update immediately after reset / mount.
  return timer(0, intervalMS).pipe(
    takeUntil(destroySubject),
    map(() => Date.now()),
  );
};

/**
 * Same as createTimerObservable but with explicit naming used in tests.
 */
export const createCustomIntervalObservable = (
  destroySubject: Subject<void>,
  intervalMS = 1000,
): Observable<number> => {
  return createTimerObservable(destroySubject, intervalMS);
};
